/// <reference path="api.d.ts" />

namespace API.Client {
    'use strict';

    export interface Bank {

        /**
         * Unique identifier of the bank
         */
        "id"?: number;

        /**
         * Name of institution
         */
        "name"?: string;

        /**
         * Short name of institution
         */
        "shortName"?: string;
    }

}
